// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedSearchDevices_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s16IconSvg = html `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M10 1.99869H2V7.99476H3.42268C3.27832 8.65151 3.24544 9.3278 3.32402 9.99345H0V0H12V3.93927C11.3673 3.61799 10.6894 3.4161 10 3.33359V1.99869Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M13.6351 11.7484C14.7158 9.84249 14.4434 7.37802 12.818 5.75366C10.8654 3.80232 7.69957 3.80232 5.74695 5.75366C3.79433 7.70501 3.79433 10.8688 5.74695 12.8201C7.37237 14.4445 9.83845 14.7167 11.7456 13.6367L15.2929 16L16 15.2934L13.6351 11.7484ZM11.4038 7.16695C12.5754 8.33776 12.5754 10.236 11.4038 11.4068C10.2322 12.5776 8.33274 12.5776 7.16117 11.4068C5.98959 10.236 5.98959 8.33776 7.16117 7.16695C8.33274 5.99615 10.2322 5.99615 11.4038 7.16695Z" class="svg-bg"/>
</svg>
`;
/**
 * IconMedSearchDevices is a generated icon component.
 */
let IconMedSearchDevices = IconMedSearchDevices_1 = class IconMedSearchDevices extends IconBaseElement {
    render() {
        return html `${IconMedSearchDevices_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedSearchDevices.icons = new Map([
    ['s8', _s16IconSvg],
    ['s12', _s16IconSvg],
    ['s16', _s16IconSvg],
    ['s24', _s16IconSvg],
    ['s32', _s16IconSvg],
    ['s40', _s16IconSvg],
    ['s48', _s16IconSvg],
    ['s64', _s16IconSvg],
    ['s72', _s16IconSvg],
    ['s80', _s16IconSvg],
]);
IconMedSearchDevices = IconMedSearchDevices_1 = __decorate([
    customElement('zui-icon-med-search-devices')
], IconMedSearchDevices);
export { IconMedSearchDevices };
